export enum Icons {
  CropRequirements = 'crop-requirements',
  LivestockLoading = 'livestock-loading',
  SlurryStorage = 'slurry-storage'
}
